import { CandidateQuery } from '@pflegia/data-access/candidate.generated';
import { CandidatePriority, E_PRIORITIES, F_PRIORITIES } from '@pflegia/types/api/candidate/candidate-priority';

export const shouldShowLowPriorityModal = (candidate: CandidateQuery['candidate']) => {
  const { hasPassword, priority, citizenships, workPermit, germanSpeakingLevel, schoolCertificate, hasLinkedSocialMedias } = candidate;

  if (!hasPassword && !hasLinkedSocialMedias) return false;

  if (!priority) return true;

  if (E_PRIORITIES.includes(priority as CandidatePriority) && (!citizenships || !workPermit || !germanSpeakingLevel || !schoolCertificate))
    return true;

  if (F_PRIORITIES.includes(priority as CandidatePriority) && (!citizenships || !workPermit || !germanSpeakingLevel)) return true;

  return false;
};
